module.exports = __webpack_public_path__ + "static/2-c843324936f385ad29981e24fe103ab3.jpeg";